import Http from '@/utils/http'
const baseUrl = '/app/student'

/**
 * 班级列表
 * 
*/

export const classList = () => Http.get(`${baseUrl}/class`)

/**
 * 加入班级
 * @param code
 * 
*/

export const joinClass = code => Http.post(`${baseUrl}/class/join/${code}` )

/**
 * 删除班级
 * @param classId
 * 
*/

export const delClass = classId => Http.delete(`${baseUrl}/class/${classId}` )

/**
 * 班级排序
 * @param params
 * 
*/

export const sortClass = params => Http.put(`${baseUrl}/class/sort`, params )

/**
 * 班级详情
 * @param id
 * 
*/

export const classInfo = id => Http.get(`${baseUrl}/class/${id}` )

/**
 * 学生列表
 * @param params
 * 
*/

export const studentList = params => Http.get(`${baseUrl}/class/user`, { params })

/**
 * 教师详情
 * @param classId
 * 
*/

export const teacherInfo = classId => Http.get(`${baseUrl}/class/${classId}/teacher` )
